// extracted by mini-css-extract-plugin
export default {"missingInstallationFallback":"C4PwqFqvgdlETUWhCfBc","title":"Qoj7Q_JFIRzVr0qT8rpY","description":"emy43Ref3iFi2vSIVNil","buttons":"MlE4SU3lR4EzS9eP3uAt"};